import { useOpenCreateLifeArea } from 'features/life-areas';
import { MobileAddButton } from 'shared/components/ui/mobile-add-button';

import * as Styled from './mobile-add-life-area-button.style';

export const MobileAddLifeAreaButton = () => {
  const onCreate = useOpenCreateLifeArea();

  return (
    <Styled.Container>
      <MobileAddButton onClick={onCreate} />
    </Styled.Container>
  );
};
